import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import FAQ from "@/views/FAQ";
import Login from "@/views/user/Login";
import Register from "@/views/user/Register";
import Activate from "@/views/user/Activate";
import FbAuth from "@/views/authenticated/FbAuth";
import Dashboard from "@/views/authenticated/Dashboard";
import ViralFinder from "@/views/authenticated/viral-finder/ViralFinder";
import BuyTokens from "@/views/authenticated/BuyTokens";
import Profile from "@/views/authenticated/Profile";
import IGAccountSpy from "@/views/authenticated/IGAccountSpy";
import Imprint from "@/views/Imprint";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import store from "../state/store.js";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/faq",
      name: "FAQ",
      component: FAQ,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/viral-finder",
      name: "viralFinderIg",
      component: ViralFinder,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/profile-spy",
      name: "IGAccountSpy",
      component: IGAccountSpy,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/buy-tokens",
      name: "BuyTokens",
      component: BuyTokens,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/register",
      name: "register",
      component: Register,
    },
    {
      path: "/activate",
      name: "activate",
      component: Activate,
    },
    {
      path: "/fb-auth",
      name: "FbAuth",
      component: FbAuth,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/imprint",
      name: "imprint",
      component: Imprint,
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
    },
  ],
  mode: "history",
});

router.beforeEach((to, from, next) => {
  store.commit("ui/show_alert", false);
  store.commit("ui/alert_text", "");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters["user/isLoggedIn"]) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
